import React from "react";

export const AppContext = {
    IsEnableMergeCalls: true,
    DocumentProtection: {
        enabled: true,
        auditApiUrl: "",
    },
    ExcelWebEdit: {
        enabled: true,
        api: {
            downloadPath: "/docs/excel",
            savePath: "/docs/excel/save",
        },
        extensions: ["xlsx", "xlsm", "csv"],

        // Default capabilities for every configured reader unless overridden.
        defaults: {
            canView: true,  // show the spreadsheet web view
            canEdit: true,  // allow editing cells
            canSave: true,  // allow saving changes back to the server
        },
        readers: {
            "srinivas.rs@rpostlabs.com": true,
            "akash.ta@yahoo.com": true,
            "akash.ta@rpostlabs.com": true,
            "sriya.in@rpostlabs.com": true,
            "shriya62024@yahoo.com": true,
            "shriyardocs@gmail.com": true,
            "ajayKumar.sa@rpostlabs.com": true,
            "pruthvi.al@rpostlabs.com": true,
            "swaroop.ch@rpostlabs.com": true,
            "preeti.ka@rpostlabs.com": true,
            "sreenath.go@rpostlabs.com": true,
            "sandeep.tu@rpostlabs.com": true,
            "subash.ct@rpostlabs.com": true,
        },
    },
};
